import dayjs from "dayjs"

/**
 * Converts trip server data → AntD form field values.
 * Called once by WizardProvider after the trip is loaded.
 *
 * Rules:
 * - No backend key changes. Field names here match what Form.Item name="" expects.
 * - available_hours strings are converted to dayjs (DaysAndHours renders TimePicker).
 * - Seasonal date ranges (seasonStart_N / seasonEnd_N) are NOT set here;
 *   SchedulingStep initializes them on mount from trip.available_date_ranges.
 */
export const buildDefaultValues = (trip) => {
  if (!trip?.id) return {}

  let categories = []
  if (Array.isArray(trip.categories)) {
    categories = trip.categories
  } else if (trip.categories) {
    categories = [trip.categories]
  }

  const availableHours = (trip.available_hours || []).map(({ start, end }) => ({
    start: start ? dayjs(start, "HH:mm") : null,
    end: end ? dayjs(end, "HH:mm") : null
  }))

  return {
    // ── Details ─────────────────────────────────────────────────────────────
    title: trip.title,
    description: trip.description,
    categories: categories.length ? categories : undefined,
    min_guests: trip.min_guests,
    max_guests: trip.max_guests,
    languages: trip.languages?.length ? trip.languages : ["english"],
    skill_levels: trip.skill_levels?.length ? trip.skill_levels : ["beginner"],
    included_items: trip.included_items,
    bring_items: trip.bring_items,
    accessibility_enabled: trip.accessibility_enabled,
    alcohol_allowed: trip.alcohol_allowed,
    children_allowed: trip.children_allowed,
    publish_on_guides_site: trip.publish_on_guides_site,
    publish_on_platform: trip.publish_on_platform,

    // ── Scheduling ───────────────────────────────────────────────────────────
    time_zone: trip.time_zone,
    pricing_type: trip.pricing_type || "per_person",
    deposit_percentage: trip.deposit_percentage || 10,
    full_payment_required: trip.full_payment_required,
    licenses_required: trip.licenses_required,
    licenses_list: trip.licenses_list,
    seasonal: trip.seasonal,
    recurringYearly: trip.available_date_ranges?.length > 0 ? trip.recurring_yearly : true,
    available_days: trip.available_days,
    available_hours: availableHours.length ? availableHours : undefined,

    // ── Location ─────────────────────────────────────────────────────────────
    address: trip.address,
    additional_directions: trip.additional_directions
  }
}
